<div>
    <i *ngIf="!rootTest&&loading" class="fa fa-spinner fa-spin mx-2"></i>
    
    <dialer-test-result-table *ngIf="rootTest;" [rootTest]="rootTest">
    </dialer-test-result-table>

    <div class="d-flex flex-row justify-content-between pt-1">
        <ng-content></ng-content>
        <div *ngIf="warningMsg">
            <i class="fa fa-exclamation-triangle text-warning"></i>&nbsp;{{warningMsg|shorten:80:'...'}}
        </div>        
    </div>
</div>

